import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';

import {
  ArrowLeftOutlined as ArrowBackIcon,
  CloseOutlined as CloseIcon,
  QuestionCircleOutlined as HelpOutlineIcon,
  RightOutlined as ArrowForwardIosIcon
} from '@ant-design/icons';
import { Button, Divider, Drawer } from 'antd';

import type { IHelperPage } from 'v2/interfaces/helperPage';
import { helperPagesFactory } from 'v2/services/helperPage';

import NoDangerouslyHTML from '../NoDangerouslyHTML';

const HelperPage = ({ title, name, id }: { title: string; name: string; id: string }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [openHint, setOpenHint] = useState<boolean>(false);
  const [helpers] = useObservable(() => helperPagesFactory.loadHelperPage(name), []);
  const [currentHint, setCurrentHint] = useState<IHelperPage>(null);

  const onClose = () => {
    setOpen(false);
    setOpenHint(false);
    setCurrentHint(null);
  };

  if (!helpers?.length) return null;

  return (
    <>
      <Button id={id} onClick={() => setOpen(true)} icon={<HelpOutlineIcon />} className='bg-white'>
        Ajuda
      </Button>

      <Drawer
        placement='right'
        open={open}
        onClose={onClose}
        title={
          <div className='flex items-center justify-between'>
            <span className='text-lg font-semibold text-[#333e58]'>{title}</span>
            <button className='cursor-pointer border-none bg-transparent' onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
        }
        closable={false}
        width={500}
        styles={{ body: { padding: 0 } }}
      >
        {openHint && (
          <div className='flex cursor-pointer items-center px-4 pt-4 pb-0' onClick={() => setOpenHint(false)}>
            <Button size='small' icon={<ArrowBackIcon />} type='text'>
              Voltar para lista
            </Button>
          </div>
        )}
        <div className='max-w-[500px] overflow-x-hidden max-md:max-w-full'>
          {openHint ? (
            <div className='p-4 text-sm'>
              <div className='mb-4 text-base font-semibold text-[#0d47a1]'>{currentHint.name}</div>
              <NoDangerouslyHTML html={currentHint.hint} />
            </div>
          ) : (
            (helpers || []).map(h => (
              <>
                <div
                  key={h.name}
                  onClick={() => {
                    setCurrentHint(h);
                    setOpenHint(true);
                  }}
                  className='flex cursor-pointer items-center justify-between p-4 text-base'
                >
                  <p className='m-0!'>{h.name}</p>
                  <button className='ml-4 cursor-pointer border-none bg-transparent'>
                    <ArrowForwardIosIcon />
                  </button>
                </div>
                <Divider className='my-0!' />
              </>
            ))
          )}
        </div>
      </Drawer>
    </>
  );
};

export default HelperPage;
